import type { ReactNode } from "react";
import { Box, Card, Grid, Stack, styled } from "~/common/mui";
import { Alert } from "~/common/mui/Alert/Alert";

export const ATC_MODAL_CLASSNAME = "scha__add-to-cart-popup";

export const AtcContentLayout = ({ info, main }: { info: ReactNode; main: ReactNode }) => {
  return (
    <Stack direction={{ phone: "column", "desktop-s": "row" }} gap={2}>
      <Box width={{ phone: "100%", "desktop-s": "240px" }}>{info}</Box>
      <Box sx={{ flex: 1 }}>{main}</Box>
    </Stack>
  );
};

interface MainAreaLayoutProps {
  packagingSlot: ReactNode;
  pricingSlot: ReactNode;
  notificationsSlot?: ReactNode;
}

export const AtcMainAreaLayout = ({ packagingSlot, pricingSlot, notificationsSlot }: MainAreaLayoutProps) => (
  <Stack sx={{ justifyContent: "space-between", height: "100%" }} gap={2}>
    <Grid
      container
      columns={{ phone: 1, "desktop-s": 3 + 2 }}
      component={Card}
      spacing={0}
      sx={{ flexGrow: 1, mx: { phone: -3, tablet: 0 } }}
    >
      <Grid size={{ phone: 1, "desktop-s": 3 }} sx={{ p: 2, backgroundColor: "surface.main" }}>
        {packagingSlot}
      </Grid>
      <Grid size={{ phone: 1, "desktop-s": 2 }} sx={{ p: 2 }}>
        {pricingSlot}
      </Grid>
    </Grid>
    <Box>{notificationsSlot}</Box>
  </Stack>
);

export const PdpMainAreaLayout = ({ packagingSlot, pricingSlot }: MainAreaLayoutProps) => (
  <Grid container columns={5 + 4} component={Card}>
    <Grid size={5} sx={{ p: 2, backgroundColor: "surface.main" }}>
      {packagingSlot}
    </Grid>
    <Grid size={4} sx={{ py: 2, px: { phone: 2, "desktop-s": 3, "desktop-l": 4 } }}>
      {pricingSlot}
    </Grid>
  </Grid>
);

export const AtcPackagingLoading = styled("div")({
  justifyContent: "center",
  width: "100%",
  height: "100%",
  alignItems: "center",
  display: "flex",
});

export const AtcOptionalPartsStack = styled(Stack)(({ theme }) => ({
  "&.scha__atc-popup--optional-parts": {
    marginTop: theme.spacing(1),
  },
}));

export const AtcDeliveryDisclaimer = styled(Alert)(({ theme }) => ({
  marginTop: theme.spacing(1.25),
  marginBottom: theme.spacing(1.25),
  width: "100%",
  "& > span": { whiteSpace: "pre-line" },
  "&.no-bottom": { marginBottom: 0 },
}));
